﻿export interface IGridSortingOptionsModel {
    columnName: string;
    sortOrder; string;
}

export class GridSortingOptionsModel {
    columnName: string;
    sortOrder; string;
}